module.exports = __webpack_public_path__ + "static/media/am_weChat.png";